/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    { if: { viewport: [ 'xs' ] }, tokens: { rowSize: 2 } },
    { if: { viewport: [ 'sm', 'md' ] }, tokens: { rowSize: 3 } },
    { if: { viewport: [ 'lg', 'xl' ] }, tokens: { rowSize: 6 } }
  ],
  tokens: {
    itemBorderColor: '#b2b9bf',
    itemPadding: 16,
    rowBorderWidth: 1,
    rowSize: 6
  }
}
export default theme
